
export default class ChatUser {
    constructor(json) {
        this.id = json['id'];
        this.nickname = json['nickname'];
        this.sendbirdUserId = json['sendbird-user-id'];
        this.profileUrl = json['profile-url'];
    }
}
